import { render } from "./Confetti.vue?vue&type=template&id=29623e48&scoped=true"
import script from "./Confetti.vue?vue&type=script&lang=js"
export * from "./Confetti.vue?vue&type=script&lang=js"

import "./Confetti.vue?vue&type=style&index=0&id=29623e48&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29623e48"]])

export default __exports__